import {deserialise} from "kitsu-core";
import * as StoreAPI from "src/core/api/shops";

export async function getStorePages(axiosInstance) {
  const response = await StoreAPI.pages(axiosInstance);
  return deserialise(response).data;
}
